import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../app/api/';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class ProfileCompletionGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url = route.url[0];
        let status = localStorage.getItem('status');
        console.log('status =>  ', status);
        if (status === '6') {
            this.router.navigate(['/demographic-profile']);
        } else if (status === '7') {
            this.router.navigate(['/lifestyle-profile']);
        } else if (status === '8') {
            this.router.navigate(['/billing-profile']);
        } else if (status === '9') {
            this.router.navigate(['/payment-info']);
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/directives/profile-completion.guard.ts